/**
 * Where the site's links go. The prototype's `sgo('page')` becomes a route; `startPlan()` becomes
 * onboarding or sign-in.
 *
 * Contact is a page of inboxes (no form), linked from the footer and the Team page. The "Book a
 * demo" and "Save me a seat" buttons open an email to the teams inbox, the alternative the
 * prototype's contact form offered. Seminars is an unlinked draft (src/site/drafts/).
 */
export const ROUTES = {
  home: "/",
  employers: "/employers",
  how: "/how-it-works",
  abi: "/what-abi-does",
  security: "/security",
  pricing: "/pricing",
  team: "/team",
  blog: "/blog",
  terms: "/terms",
  privacy: "/privacy",
  contact: "/contact",
  start: "/start",
  signin: "/signin",
  app: "/app",
} as const;

export const INFO_EMAIL = "info@wealthyplanet.com";
export const TEAMS_EMAIL = "Abiforbusiness@wealthyplanet.com";
export const SUPPORT_EMAIL = "support@wealthyplanet.com";
export const SECURITY_EMAIL = "security@wealthyplanet.com";

export const CONTACT_HREF = `mailto:${TEAMS_EMAIL}?subject=${encodeURIComponent("Abi for my team")}`;
export const SEMINAR_HREF = `mailto:${TEAMS_EMAIL}?subject=${encodeURIComponent(
  "Save me a seat on Tuesday",
)}`;
export const LINKEDIN_HREF = "https://www.linkedin.com/company/wealthyplanet";
